/**
 * Helpers for date and time operations
 */

/**
 * Return localized date string from `date` param, which can be String or Date object.
 */
export const toLocaleDateString = (date, locale, options) => {
    try {
        const d =
            typeof date === 'object' ?
                date
                : new Date(date);

        const defaultOptions = { month: "numeric", day: "numeric", year: "numeric" };
        return d ?
            new Intl.DateTimeFormat(locale, options || defaultOptions).format(d)
            : '';
    }
    catch (error) {
        console.debug(error);
        return '';
    }
};

/**
 * Gets the item's first DateEdited.
 */
export const getFirstDateEdited = function (item) {
    const editor = item?.Editors?.length && item.Editors[0];
    return editor && editor.DateEdited;
};

export default {
    toLocaleDateString,
    getFirstDateEdited
};
